import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

export function PlaceholderPage() {
  const { t } = useTranslation();
  return (
    <section className="placeholder-panel">
      <Empty description={t('common.comingSoon')} />
    </section>
  );
}
